import { render, staticRenderFns } from "./Story_Header.vue?vue&type=template&id=7a634d8d&"
import script from "./Story_Header.vue?vue&type=script&lang=js&"
export * from "./Story_Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports